<mat-form-field appearance="fill">
    <mat-label>{{ label }}</mat-label>
    <mat-select [formControl]="periodCtrl" name="period">
        <mat-option *ngFor="let period of periods" [value]="period.value">
            {{ period.label }}
        </mat-option>
    </mat-select>
</mat-form-field>
<div
    class="d-flex align-items-baseline mx-n3 ms-0 ms-sm-n3"
    *ngIf="periodCtrl.value !== 'custom'"
>
    <button
        type="button"
        class="btn link flex-shrink-0"
        (click)="selectPrevious(periodCtrl.value)"
    >
        <tabler-icon name="chevron-left"></tabler-icon>
    </button>
    <mat-form-field appearance="fill" *ngIf="periodCtrl.value === 'month'">
        <mat-label>Month and year</mat-label>
        <input
            readonly
            matInput
            [matDatepicker]="dp"
            [formControl]="fromDateCtrl"
            datePickerFormat="MMMM yyyy"
            style="text-transform: capitalize"
            (click)="dp.open()"
        />
        <mat-hint>Select year and month</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="dp">
            <i-tabler matDatepickerToggleIcon name="calendar"></i-tabler>
        </mat-datepicker-toggle>
        <mat-datepicker
            #dp
            startView="multi-year"
            (monthSelected)="setMonthAndYear($event, dp)"
        ></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="fill" *ngIf="periodCtrl.value === 'year'">
        <mat-label>Year</mat-label>
        <input
            matInput
            readonly
            [matDatepicker]="dp"
            [formControl]="fromDateCtrl"
            (click)="dp.open()"
            datePickerFormat="yyyy"
        />
        <mat-hint>Select year</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="dp">
            <i-tabler matDatepickerToggleIcon name="calendar"></i-tabler>
        </mat-datepicker-toggle>
        <mat-datepicker
            #dp
            startView="multi-year"
            (yearSelected)="setYear($event, dp)"
        ></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="fill" *ngIf="periodCtrl.value === 'quarter'">
        <mat-label>Quarter</mat-label>
        <input
            matInput
            readonly
            [matDatepicker]="dp"
            [formControl]="fromDateCtrl"
            (click)="dp.open()"
            datePickerFormat="QQQ - yyyy"
        />
        <mat-hint>Select year and quarter</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="dp">
            <i-tabler matDatepickerToggleIcon name="calendar"></i-tabler>
        </mat-datepicker-toggle>
        <mat-datepicker
            #dp
            startView="multi-year"
            (monthSelected)="setQuarterAndYear($event, dp)"
        ></mat-datepicker>
    </mat-form-field>
    <button
        type="button"
        class="btn link flex-shrink-0"
        (click)="selectNext(periodCtrl.value)"
    >
        <tabler-icon name="chevron-right"></tabler-icon>
    </button>
</div>
<mat-form-field appearance="fill" *ngIf="periodCtrl.value === 'custom'">
    <mat-label>From and to date</mat-label>
    <mat-date-range-input [rangePicker]="dp">
        <input matStartDate [formControl]="fromDateCtrl" placeholder="From date" />
        <input matEndDate [formControl]="toDateCtrl" placeholder="To date" />
    </mat-date-range-input>
    <mat-hint>Select from and to date</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="dp">
        <i-tabler matDatepickerToggleIcon name="calendar"></i-tabler>
    </mat-datepicker-toggle>
    <mat-date-range-picker #dp></mat-date-range-picker>
</mat-form-field>
